export default {
    name: "billOfLoadingManage",
    mounted: function () {
        this.init();
    },
    data() {
        return {
            searchForm: {
                // 提单编码
                blNo: null,
                // 收单公司
                receiveCompanyName: null,
                // 出单公司
                sendCompanyName: null,
                // 签章公司
                signatureCompanyName: null,
                // 出单费公司
                sendBillFeeCompanyName: null,
                // 创建日期
                createTime: null,
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            selected: [],
            total: 0,
            systemCode: null,
            // 防伪码显示标识
            securityCodeShow: false,
            // 防伪码详情数据源
            securityCodeList: []
        }
    },
    methods: {
        init(){
            // 当前系统赋值
            this.systemCode = JSON.parse(sessionStorage.getItem('currentSystem')).code;
            console.log(this.systemCode);
            let conditionParam = this.$routerUtil.getParam();
            if(conditionParam && conditionParam.searchForm){
                conditionParam = conditionParam.searchForm;
            }
            console.log(conditionParam);
            this.$routerUtil.clearParam();
            if(conditionParam){
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
            }
        },
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.pageIndex = val;
            this.doSearch();
        },
        rowClick(row){
            this.$refs.table.toggleRowSelection(row);
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        doReset(){
            this.searchForm.blNo="";
            this.searchForm.receiveCompanyName="";
            this.searchForm.sendCompanyName="";
            this.searchForm.signatureCompanyName="";
            this.searchForm.sendBillFeeCompanyName="";
        },
        doAdditionalPrinting(){

        },
        doSearch() {
            this.loading = this.$loading({
                lock: false,
                text: this.$t('blOrderTrack.isSearching'),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const param = Object.assign({}, this.$paramUtil.clearEmpty(this.searchForm));
            if(param.createTime){
                param.createTimeStart = param.createTime[0];
                param.createTimeEnd = param.createTime[1];
            }
            delete param.createTime;
            this.$axios({
                method: "get",
                url: "api/billOfLadings/billOfLoadingAllInfo", // 接口地址
                params:param
            }).then(res => {
                this.tableData = res.data.resultData.rows;
                this.total = res.data.resultData.total;
                this.loading.close();
            }).catch(error => {
                console.log(error);
                this.loading.close();
                this.$message({
                    message: 'This is an error message',
                    type: 'error',
                    center: true
                });
            }); // 失败的返回
        },
        doDetail(){
            const row = this.getSelectedRow();
            if (row) {
                const conditionData = new Object();
                conditionData.searchForm = this.searchForm;
                conditionData.row = row;
                this.$router.push('BillDetail');
                this.$routerUtil.setParam(conditionData);
            }
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        },
        // 显示防伪码详情
        showSecurityCodeDetail(row) {
            this.securityCodeShow = true;
            const securityHashCode = row.billSignatureFileList.filter(item => item.isSignature === 1 && item.billSignatureFileType === 1)[0].hashCode;
            row.billOfLoadingFileList.forEach(item => {
                let securityCodeItem = {};
                let showSecurityCodeStr = securityHashCode + "_";
                if (item.billOfLoadIngFileType === 1) {
                    showSecurityCodeStr += "zb" + item.fileNo;
                    securityCodeItem.securityCode = showSecurityCodeStr;
                    securityCodeItem.status = (item.isEffective === 1 ? this.$t('blOrderTrack.effective') : this.$t('blOrderTrack.void'));
                    this.securityCodeList.push(securityCodeItem);
                }
            });
        },
        // 关闭防伪码详细
        closeSecurityCode(){
            this.securityCodeShow = false;
            this.securityCodeList = [];
        }
    }
}
